import React from 'react';
import { TrendingUp, AlertCircle, Lightbulb } from 'lucide-react';
import { TaraCard, TaraCardHeader, TaraCardTitle, TaraCardContent } from '../components/ui/TaraCard';
import TaraBadge from '../components/ui/TaraBadge';
import BottomNav from '../components/BottomNav';

const HomeNew = () => {
  const userName = localStorage.getItem('userName') || 'Friend';
  const timeOfDay = new Date().getHours() < 12 ? 'morning' : 
                    new Date().getHours() < 18 ? 'afternoon' : 'evening';
  
  return (
    <div className="min-h-screen bg-stone-50 pb-24">
      {/* Header */}
      <div className="bg-cosmic-dawn px-5 pt-12 pb-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl font-medium text-stone-900">
            ☀️ Good {timeOfDay}, {userName}
          </h1>
        </div>
      </div>
      
      {/* Content */}
      <div className="px-5 py-6 max-w-2xl mx-auto space-y-6 -mt-4">
        {/* Hero Vitality Card */}
        <TaraCard variant="cosmic" glowing className="p-8">
          <div className="text-center space-y-6">
            <h2 className="font-serif text-2xl font-medium text-stone-900">
              Overall Vitality
            </h2>
            
            {/* Arc Meter */}
            <div className="relative w-48 h-24 mx-auto">
              <svg viewBox="0 0 100 50" className="w-full h-full">
                <path
                  d="M 10 45 A 40 40 0 0 1 90 45"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="8"
                  className="text-stone-200"
                />
                <path
                  d="M 10 45 A 40 40 0 0 1 90 45"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="8"
                  strokeDasharray="126"
                  strokeDashoffset={126 - (126 * 0.83)}
                  className="text-cosmic-500"
                />
              </svg>
              <div className="absolute inset-0 flex items-end justify-center pb-2">
                <span className="font-serif text-4xl font-medium text-stone-900">
                  8.3
                </span>
                <span className="text-lg text-stone-600 ml-1">/10</span>
              </div>
            </div>
            
            {/* Insights */}
            <div className="space-y-2 text-left">
              <div className="flex items-start gap-2">
                <TrendingUp className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-stone-700">
                  High resilience period continues till 2027
                </p>
              </div>
              <div className="flex items-start gap-2">
                <AlertCircle className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-stone-700">
                  Focus on sleep quality & back posture this year
                </p>
              </div>
            </div>
          </div>
        </TaraCard>
        
        {/* Quick Cards Grid */}
        <div className="grid grid-cols-2 gap-4">
          <TaraCard interactive>
            <TaraCardHeader>
              <TaraCardTitle className="text-lg">This Week</TaraCardTitle>
            </TaraCardHeader>
            <TaraCardContent>
              <p className="text-sm text-stone-600">
                Energy levels stable. Good time for physical activity.
              </p>
            </TaraCardContent>
          </TaraCard>
          
          <TaraCard interactive>
            <TaraCardHeader>
              <TaraCardTitle className="text-lg">Next Key Phase</TaraCardTitle>
            </TaraCardHeader>
            <TaraCardContent>
              <TaraBadge variant="watchful">Mar 2026</TaraBadge>
              <p className="text-sm text-stone-600 mt-2">
                Saturn transit begins
              </p>
            </TaraCardContent>
          </TaraCard>
        </div>
        
        {/* Suggestion of the Day */}
        <TaraCard variant="sacred">
          <TaraCardHeader>
            <div className="flex items-center gap-2">
              <Lightbulb className="w-5 h-5 text-sacred-600" />
              <TaraCardTitle className="text-lg">Suggestion of the Day</TaraCardTitle>
            </div>
          </TaraCardHeader>
          <TaraCardContent>
            <p className="text-sm text-stone-700">
              Practice 10 minutes of pranayama today. Your moon is well-placed for breathing exercises.
            </p>
          </TaraCardContent>
        </TaraCard>
      </div>
      
      {/* Bottom Navigation */}
      <BottomNav active="home" />
    </div>
  );
};

export default HomeNew;